import React, { useEffect, useState } from "react";
import { Button, Form, message, Select, Space, Switch } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { ISupplierDetail } from "../supplierTypes";
import { useSupplierModel } from "../supplierModel"
import { DetailType } from "../../../../types/FmsEnums";
import { useNavModel } from "../../../../model/navModel";
import { globalPrompt } from "../../../../components2/YhMessage"
import { YHModal } from "../../../../components2/YHModal";
import useMdmModel from "../../../../model/mdmModel";

const SupplierList = () => {
    const { dataSource, page, searchParam, selectedRow, loadData, checkLoadData, cutDisabled, setSelectedRow, shopModel, setShopModel, userModel, setUserModel, onShareShop, onShareUser } = useSupplierModel()
    const { addNav } = useNavModel()
    const { userAll, shop } = useMdmModel();
    const [shopChangeList, setShopChangeList] = useState<any>([]);
    const [userChangeList, setUserChangeList] = useState<any>([]);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ISupplierDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '分支编码',
            dataIndex: 'branch',
        },
        {
            title: '数据版本号',
            dataIndex: 'ver',
        },
        {
            title: '供应商编码',
            dataIndex: 'code',
        },
        {
            title: '供应商名称',
            dataIndex: 'name',
        },
        {
            title: '供应商类型',
            dataIndex: 'categoryName',
        },
        {
            title: '关联门店',
            dataIndex: 'shopSuppliers',
            render: (beDetails: any) => {
                if (beDetails && beDetails.length) {
                    return beDetails.map((item: any) => item.name).join()
                }
                return ""
            }
        },
        {
            title: '关联用户',
            dataIndex: 'userSuppliers',
            render: (beDetails: any) => {
                if (beDetails && beDetails.length) {
                    return beDetails.map((item: any) => item.name).join()
                }
                return ""
            }
        },
        {
            title: '联系人',
            dataIndex: 'contact',
        },
        {
            title: '联系电话',
            dataIndex: 'phone',
        },
        {
            title: '联系地址',
            dataIndex: 'address',
        },
        {
            title: '办公电话',
            dataIndex: 'tel',
        },
        {
            title: '传真',
            dataIndex: 'fax',
        },
        {
            title: '创建人',
            dataIndex: 'createUser',
        },
        {
            title: '登记时间',
            dataIndex: 'createTime',
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
        {
            title: '状态',
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    {/* checked={record.materialStatus == 0} */}
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        // onDisabled(record.id, checked);
                        cutDisabled(record, checked)
                    }} />
                </Space>
            ),

        }
    ];
    const onDetail = (type: string) => {
        const id = selectedRow[0]?.key as string //这里做类型转换
        switch (type) {
            case DetailType.add:
                return addNav("2-9-1", { id: "", mode: type })
            case DetailType.edit:
                if (selectedRow.length == 0) return globalPrompt("message", { type: "error", text: "选择您要编辑的数据" })
                return addNav("2-9-2", { id, mode: type });
            case DetailType.look:
                if (selectedRow.length == 0) return globalPrompt("message", { type: "error", text: "选择您要查看的数据" })
                return addNav("2-9-3", { id, mode: type });
            default:
                return false
        }
    }

    const onOpen = (flag: "user" | "shop") => {
        if (selectedRow.length > 0) {
            (flag === "shop" ? setShopModel : setUserModel)(true);
        }
        else if (Object.keys(searchParam).length > 0) {
            checkLoadData().then(res => (flag === "shop" ? setShopModel : setUserModel)(true));
        }
        else {
            globalPrompt("message", { type: "error", text: "选择您要编辑的数据或者相应条件的所有数据" });
        }
    }

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("add")}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("edit")}
        >编辑</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("look")}
        >查看</Button> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onOpen("shop")}
        >门店共享</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onOpen("user")}
        >用户共享</Button>
    </>


    const onShopOK = async () => {
        if (selectedRow.length == 0) return globalPrompt("message", { type: "warning", text: "请先选择供应商" })
        if (shopChangeList.length == 0) return globalPrompt("message", { type: "warning", text: "请选择共享门店" })
        let data = {
            listShop: shopChangeList.map((item: any) => ({ name: item.label, code: item.value })),
            list: selectedRow.map((item) => ({ name: item.name, code: item.code }))
        }
        await onShareShop(data).then(res => {
            if (res) {
                globalPrompt("message", { type: "success", text: res })
                onShopCancel()
            }
        })
    }
    const onShopCancel = () => {
        setShopModel(false)
        setSelectedRow([])
    }
    const onUserOK = async () => {
        if (selectedRow.length == 0) return globalPrompt("message", { type: "warning", text: "请先选择供应商" })
        if (userChangeList.length == 0) return globalPrompt("message", { type: "warning", text: "请选择共享用户" })
        let data = {
            listUser: userChangeList.map((item: any) => ({ name: item.label, code: item.value })),
            list: selectedRow.map((item) => ({ name: item.name, code: item.code }))
        }
        await onShareUser(data).then(res => {
            if (res) {
                globalPrompt("message", { type: "success", text: res })
                onShopCancel()
            }
        })
        onUserCancel()
    }

    const onUserCancel = () => {
        setUserModel(false)
        setSelectedRow([])
    }

    const delSelectRow = (data: ISupplierDetail) => {
        setSelectedRow((origin: ISupplierDetail[]) => origin.filter(item => item.key !== data.key));
    }

    const modelColumns: ColumnsType<ISupplierDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '供应商编码',
            dataIndex: 'code',
        },
        {
            title: '供应商名称',
            dataIndex: 'name',
        },
        {
            title: '操作',
            dataIndex: 'enable',
            render: (text, record) => (
                <Button size="small" type="link" onClick={() => delSelectRow(record)}>删除</Button>
            ),
        }
    ]

    //点击行选高亮
    const onRow = (record: ISupplierDetail) => {
        let findObj = selectedRow.find(item => item.key === record.key)
        if (findObj) {
            let newSelectedRowKeys = selectedRow.filter(item => item.key !== record.key);
            setSelectedRow(newSelectedRowKeys);
        } else {
            setSelectedRow(origin => [...origin, record]);
        }
    };

    return (
        <YhBox action={action}>
            <Table
                columns={columns}
                dataSource={dataSource}
                rowSelection={{
                    //全部选中时
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        selected ? setSelectedRow((origin) => [...origin, ...changeRows])
                            : setSelectedRow((origin) => {
                                let changeRowId = changeRows.map(item => item.key);
                                return origin.filter(item => changeRowId.indexOf(item.key) < 0)
                            });
                    },
                    onSelect: (record, selected, selectedRows) => onRow(record),
                    selectedRowKeys: selectedRow.map(item => item?.key ?? "")
                }}
                onRow={record => ({
                    onClick: () => onRow(record),
                })}
                pagination={{
                    ...page,
                    position: ["bottomCenter"],
                    showTotal: () => `共${page.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
            <YHModal
                visible={shopModel}
                onOk={onShopOK}
                onCancel={onShopCancel}
                title="门店共享"
                width={600}
                bodyHeight={500}
                showFooter={true}>
                <div className="p-20">

                    <Form>
                        <Form.Item
                            label="共享门店"
                            name="shop"
                            rules={[{ required: true, message: '请选择客户' }]}
                        >
                            <Select
                                mode="multiple"
                                options={shop}
                                onChange={(val, options) => {
                                    console.log(val, options)
                                    setShopChangeList(options)
                                }}
                            ></Select>
                        </Form.Item>
                    </Form>
                    <Table
                        columns={modelColumns}
                        dataSource={selectedRow}
                        pagination={false}
                    />
                </div>
            </YHModal>
            <YHModal
                visible={userModel}
                onOk={onUserOK}
                onCancel={onUserCancel}
                title="用户共享"
                width={600}
                bodyHeight={500}
                showFooter={true}>
                <div className="p-20">
                    <Form>
                        <Form.Item
                            label="共享用户"
                            name="shop"
                            rules={[{ required: true, message: '请选择客户' }]}
                        >
                            <Select
                                mode="multiple"
                                options={userAll}
                                onChange={(val, options) => {
                                    console.log(val, options)
                                    setUserChangeList(options)
                                }}
                            ></Select>
                        </Form.Item>
                    </Form>
                    <Table
                        columns={modelColumns}
                        dataSource={selectedRow}
                        pagination={false}
                    />
                </div>
            </YHModal>
        </YhBox>
    )
}
export default SupplierList